import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { setBasicAuth, isLoggedIn, checkAuth } from "../api/auth";

function LoginPage() {
    var navigate = useNavigate();
    var location = useLocation();

    var [form, setForm] = useState({ username: "", password: "" });
    var [error, setError] = useState(null);
    var [loading, setLoading] = React.useState(false);

    useEffect(function () {
        if (isLoggedIn()) {
            navigate("/admin/produkty"); // už prihlásený
        }
    }, [navigate]);

    function handleChange(e) {
        var name = e.target.name;
        var value = e.target.value;
        var copy = Object.assign({}, form);
        copy[name] = value;
        setForm(copy);
    }

    function handleSubmit(e) {
        e.preventDefault();
        setError(null);
        setLoading(true);

        if (!form.username || !form.password) {
            setError("Zadaj meno aj heslo.");
            return;
        }

        checkAuth(form.username, form.password)
            .then(function(ok){
                if (!ok) {
                    setError("Zlé používateľské meno alebo heslo.");
                    return;
                }
                setBasicAuth(form.username, form.password);

                navigate(location.state?.from || "/admin/produkty");

            })
            .catch(function(){
                setError("Nepodarilo sa overiť prihlásenie. Skúste znova.");
            })
            .finally(function(){ setLoading(false); });
    }

    return (
        <div className="container py-4" style={{maxWidth:"520px"}}>
            <h1 className="h4 mb-3">Prihlásenie do administrátorskej zóny</h1>
            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit} className="row g-3">
                <div className="col-12">
                    <label className="form-label">Používateľské meno</label>
                    <input
                        name="username"
                        className="form-control"
                        value={form.username}
                        onChange={handleChange}
                        autoComplete="username"
                        required
                    />
                </div>

                <div className="col-12">
                    <label className="form-label">Heslo</label>
                    <input
                        name="password"
                        type="password"
                        className="form-control"
                        value={form.password}
                        onChange={handleChange}
                        autoComplete="current-password"
                        required
                    />
                </div>

                <div className="col-12 d-flex gap-2">
                    <button type="submit" className="btn btn-brown rounded-pill px-4" disabled={loading}>
                        {loading ? "Overujem…" : "Prihlásiť"}
                    </button>
                    <Link to="/" className="btn btn-outline-secondary rounded-pill">Zrušiť</Link>
                </div>

            </form>
        </div>
    );
}

export default LoginPage;
